__webpack_require__.p = "/AcademicWeapon/";